import React from 'react';
import * as Styled from './KlaraAndWhatsapp.styled';

const KlaraDetails = () => {
  return (
    <>
      <Styled.Label>Send us a message via Klara</Styled.Label>
      <Styled.Text>
        <a>315-659-9094</a>
      </Styled.Text>
    </>
  );
};

export default KlaraDetails;
